const Multipay = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
        {...props}
    >
        <path d="M3.044 15.395 2 14.35l9.84-9.85H2.894V3h11.5v11.5h-1.5V5.554l-9.85 9.84Z" />
        <path
            fill-rule="evenodd"
            d="m16 20.27.73.73 4.228-4.224v3.747H22V15h-5.523v1.043h3.747L16 20.27Zm.262 0 4.409-4.412-4.41 4.413Zm.4-4.412v-.673h5.153-5.153v.673Z"
            clip-rule="evenodd"
        />
    </svg>
);

export default Multipay;
